import React, { useEffect, useRef, useState } from "react";
import "./HomeResidence.css";

const HomeResidence = () => {
  const sectionRef = useRef(null);
  const [active, setActive] = useState(false);

useEffect(() => {
  const handleScroll = () => {
    const section = sectionRef.current;
    if (!section) return;

    const rect = section.getBoundingClientRect();

    const sectionCenter = rect.top + rect.height / 2;
    const screenCenter = window.innerHeight / 2;

    const threshold = 80; // adjust sensitivity

    if (Math.abs(sectionCenter - screenCenter) < threshold) {
      setActive(true);
    } else {
      setActive(false);
    }
  };

  window.addEventListener("scroll", handleScroll);
  handleScroll();

  return () => window.removeEventListener("scroll", handleScroll);
}, []);
  return (
    <section className="home-res-section" ref={sectionRef}>
      <div className="container-fluid">
        <div className="container text-center home-res-content">
          <h2 className="home-res-heading page-heading">Luxury  Residence</h2>
          <p className="home-res-desc">
At Mega, amalgamation of sobriety with the neutral tones of furnishings, 
fixtures, and artwork create a classical ambiance that
 embraces the lighting of early morning and late afternoon.
          </p>
        </div>

        {/* GRID */}
        <div className={`home-res-grid ${active ? "active" : ""}`}>
          
          {/* COL 1 */}
          <div className="home-res-col col-1">
            <img src= {require("../assets/gallery/454x490.jpg.jpeg")} alt="" />
          </div>

          {/* COL 2 */}
          <div className="home-res-col col-2">
            <img src= {require("../assets/gallery/290x180.jpeg")} alt="" />
            <img src= {require("../assets/gallery/290x180 2.jpg.jpeg")} alt="" />
          </div>

          {/* COL 3 (CENTER) */}
    {/* COL 3 (CENTER) */}
<div className="home-res-col col-3">
  
  {/* ✅ WRAPPER ADD */}
  <div className="center-img-wrapper">

    <img src={require("../assets/gallery/620x490.jpg.jpeg")} alt="" />

    {/* ✅ BLACK OVERLAY */}
    <div className="center-dark-overlay"></div>

    {/* ✅ TEXT */}
    <div className={`center-overlay ${active ? "show" : ""}`}>
      <h3 className="text-white">Elegant Living</h3>

      <p>
        Discover the true meaning of Elegant Living at Mega Green City, where 
        modern luxury seamlessly blends with nature's tranquility.
      </p>

      <p>
        The vibrant, fresh energy of true elegance is brought to life in every corner of this thoughtfully designed community.
        Embrace a lifestyle where simplicity, comfort, and nature come together.
      </p>

      <button className="floor-btn">
        <span>Floor Plans</span>
      </button>
    </div>

  </div>
</div>

          {/* COL 4 */}
          <div className="home-res-col col-4">
            <img src= {require("../assets/gallery/290x290.jpeg")} alt="" />
            <img src= {require("../assets/gallery/290x290.jpg.jpeg")} alt="" />
          </div>

          {/* COL 5 */}
          <div className="home-res-col col-5">
            <img src= {require("../assets/gallery/454x490 (2).jpg.jpeg")} alt="" />
          </div>

        </div>
      </div>
    </section>
  );
};

export default HomeResidence;